








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class TrackingOrderNonUpdatedCountLabel extends Vue {
  @Prop({ type: Number, required: true }) count: number;

  get color() {
    if (this.count > 5) {
      return 'red';
    }

    if (this.count >= 3) {
      return 'orange';
    }

    return 'green';
  }
}
